import * as React from "react";
import Head from "next/head";
import Footer from "../components/Footer";
import Layout from "../components/Layout";
import Header from "../components/Header";
import Try from "../components/Try";

export default function IndexRoute() {
  return (
    <>
        <Head>
            <title>Try TacBoard</title>
            <meta name="description" content="Don't miss a moment from your wedding day. TacBoard is the easiest way to collect your wedding guests' photos. No app. No wedding hashtag hassle. Just text message." />
            <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Aleo:200,300,400,700|Montserrat:300,400,500,700" />
                <link rel="canonical" href="https://tacboard.com/try-tacboard" />
        </Head>

      <Layout classes={["try-tac", "public"]}>
        <Header />
        <Try />
        <Footer />
      </Layout>
    </>
  );
};
